import { supabase } from "@/integrations/supabase/client";

export interface GenerateQuizParams {
  userId: string;
  contentId?: string | null;
  title?: string;
  description?: string;
  questionCount?: number;
  questionTypes?: string[];
  difficulty?: string;
  topics?: string[];
  instructions?: string;
  sourceContext: string;
}

export interface GenerateQuizResult {
  quiz_id: string;
  question_count: number;
  status: string;
}

export async function generateQuizFromText(params: GenerateQuizParams): Promise<GenerateQuizResult> {
  const {
    userId,
    contentId,
    title,
    description,
    questionCount = 5,
    questionTypes = ["multiple_choice", "true_false"],
    difficulty = "medium",
    topics = [],
    instructions,
    sourceContext,
  } = params;

  const { data, error } = await supabase.functions.invoke("create-quiz", {
    body: {
      user_id: userId,
      content_id: contentId || null,
      title: title || "Quiz from Selection",
      description: description || null,
      question_count: questionCount,
      question_types: questionTypes,
      difficulty,
      topics,
      instructions: instructions || null,
      source_context: sourceContext,
    },
  });

  if (error) {
    console.error("Quiz generation error:", error);
    throw new Error(error.message || "Failed to generate quiz");
  }

  if (data?.error) {
    throw new Error(data.error);
  }

  return data as GenerateQuizResult;
}
